import { Delete, Edit } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { tableConfig } from "./config/tableConfig";
import TitleContainer from "./utilsTable/titleWithFetchData";

const crudArtTable = ({
  arts,
  loading,
  fetchArts,
  handleOpenModalEditar,
  handleOpenModalEliminar,
}) => {
  const columns = [
    {
      header: "Razón social",
      accessorKey: "nombre",
    },
    {
      header: "Nombre corto",
      accessorKey: "nombreCorto",
    },
    {
      header: "Acciones",
      enableColumnFilter: false,
      enableColumnActions: false,
      accessorKey: "acciones",
      Cell: ({ row }) => (
        <div>
          <Tooltip title="Editar ART">
            <IconButton
              color="inherit"
              onClick={() => handleOpenModalEditar(row.original)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar ART">
            <IconButton
              color="inherit"
              onClick={() => handleOpenModalEliminar(row.original)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div>
      <MaterialReactTable
        {...tableConfig}
        columns={columns}
        data={arts}
        state={{ isLoading: loading }}
        renderTopToolbarCustomActions={() => (
          <TitleContainer title="ARTs" fetchData={fetchArts} />
        )}
      />
    </div>
  );
};
export default crudArtTable;
